export const MSG_REQUIRED_FIELDS_FORM = 'Existem campos de preenchimento obrigatório que não foram preenchidos.'
